import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

/** Light surfaces (yellow / white / gray blocks): dark text, white option list. */
export const multiSelectLightVars: MotifComponentProps<MotifComponent.MULTI_SELECT> = {
  '--multi-select-bg-color': m('--neutral-v0'),
  '--multi-select-fg-color': m('--neutral-v700'),
  '--multi-select-chip-bg-color': m('--neutral-v250'),
  '--multi-select-hover-border-color': m('--neutral-v400'),
  '--multi-select-option-fg-color': m('--neutral-v700'),
} as const;

/** Dark block: light text on the control; option list stays on a light panel with dark type. */
export const multiSelectDarkVars: MotifComponentProps<MotifComponent.MULTI_SELECT> = {
  '--multi-select-bg-color': m('--neutral-v0'),
  '--multi-select-fg-color': m('--neutral-v0'),
  '--multi-select-chip-bg-color': m('--neutral-v500'),
  '--multi-select-hover-border-color': m('--neutral-v400'),
  '--multi-select-option-fg-color': m('--neutral-v700'),
} as const;
